const LocationHeaderMapping = {
  Input: 'input',
  Output: 'output',
};

module.exports = { LocationHeaderMapping };
